"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT_LENGTH = exports.EventItemType = void 0;
var EventItemType;
(function (EventItemType) {
    EventItemType["START"] = "EventItemType/START";
    EventItemType["END"] = "EventItemType/END";
    EventItemType["SEGMENT"] = "EventItemType/SEGMENT";
})(EventItemType = exports.EventItemType || (exports.EventItemType = {}));
exports.SEGMENT_LENGTH = 14.285714285714285;
